var map = {
	"./music-instructions.json": 5163,
	"./music-library-intro2024.json": 5164,
	"./music-library-launch2024.json": 5165,
	"./music-progression.json": 5166,
	"./startSourcesAdvanced.json": 5167,
	"./startSourcesSimple.json": 5168,
	"./startSourcesSimple2.json": 5169,
	"./startSourcesTracks.json": 5170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4855;